"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewStatus = void 0;
const typescript_events_1 = __importDefault(require("typescript.events"));
;
class ViewStatus extends typescript_events_1.default {
    constructor(initialStatus) {
        super();
        this.value = 'loading';
        if (initialStatus)
            this.Value = initialStatus;
    }
    static new(initialStatus) {
        return new this(initialStatus);
    }
    get Value() { return this.value; }
    set Value(v) {
        const oldV = this.value;
        if (this.value !== v) {
            this.value = v;
            this.emit('changed', { status: v, old: oldV });
            this.emit(v, { status: v, old: oldV });
        }
    }
    get isLoading() { return this.Value === 'loading'; }
    get isSaving() { return this.Value === 'saving'; }
    get isErrored() { return this.Value === 'errored'; }
    get isOk() { return this.Value === 'ok'; }
    get isEmpty() { return this.Value === 'empty'; }
    get isComplete() { return this.Value === 'complete'; }
    get isPending() { return this.Value === 'pending'; }
    get isRunning() { return this.Value === 'running'; }
    get isStoped() { return this.Value === 'stoped'; }
    set(value) {
        if (typeof value === 'string') {
            this.Value = value;
        }
        else {
            this.Value = value === null || value === void 0 ? void 0 : value.Value;
        }
    }
    setLoading() { this.Value = 'loading'; }
    setSaving() { this.Value = 'saving'; }
    setErrored() { this.Value = 'errored'; }
    setOk() { this.Value = 'ok'; }
    setEmpty() { this.Value = 'empty'; }
    setComplete() { this.Value = 'complete'; }
    setPending() { this.Value = 'pending'; }
    setRunning() { this.Value = 'running'; }
    setStoped() { this.Value = 'stoped'; }
    on(eventName, listener) {
        return super.on(eventName, listener);
    }
}
exports.ViewStatus = ViewStatus;
